import React from 'react';
import useStyles from './styles';
import welcome from 'src/img/welcome.svg';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';
export default function WelcomeModalContent(_ref) {
  let handleClose = _ref.handleClose;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.modal
  }, /*#__PURE__*/React.createElement("img", {
    src: welcome,
    width: "270",
    height: "200",
    alt: "Welcome to Livable!"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('Welcome to Livable!')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('Your Appfolio account has been successfully synced with Livable. Livable now automatically receives your property and resident information from Appfolio. The properties are listed below. Before billing your residents, please activate your properties. ')), /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    onClick: () => handleClose(),
    'custom-attribute': '421-WelcomeModalContent'
  }, "Done"));
}